module.exports = __webpack_public_path__ + "static/scale-model-of-haunted-atx-in-austin-texas-9c17623a9a3693d25860a2b9fa657e27.png";